import { Helmet } from 'react-helmet'

import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { AppContextProvider, useAppContext } from 'context/app-context'

const PageTitle = () => {
  const { strings } = useAppContext()

  return (
    <Helmet>
      <title>{strings.title}</title>
    </Helmet>
  )
}

function App() {
  return (
    <>
      <Helmet
        htmlAttributes={{
          dir: 'ltr',
          lang: 'sh',
        }}
      />
      <GlobalStyle />
      <AppContextProvider>
        <PageTitle />
        <Home />
      </AppContextProvider>
    </>
  )
}

export default App
